const hash = window.location.hash.replace('#', '');

const hashLinks = document.querySelectorAll('.hash_link');

hashLinks.forEach(link => {
  link.addEventListener('click', (e) => {
    const href = e.target.href.split('#')[1];
    window.location.hash = href;
    hashLinks.forEach(el => el.classList.remove('active'));
    e.target.classList.add('active');
    const hashDisplay = document.querySelector(`[data-hash="${ href }"]`);
    const otherHashDisplays = Array.from(document.querySelectorAll('[data-hash]')).filter(el => el !== hashDisplay);
    otherHashDisplays.forEach(el => {
      el.style.display = 'none';
    });
    hashDisplay.style.display = 'block';
  });
})

if (hash) {
  const hashLink = document.querySelector(`.hash_link[href="#${ hash }"`);
  hashLink.click();
}